import {Message} from "./message";
import {TaxiMessage} from "./taxi-message";

export class newTaxiOrder implements TaxiMessage {
  constructor(public orderId: number,public draftId: number) {}
  getDraftId(): number {
    return this.draftId;
  }
}
